<ng-container *ngIf="permConfig.isAddAllowed">
<div class="container-fluid">
    <app-page-title title="Charge Master"></app-page-title>
    <form [formGroup]="chargesForm" (ngSubmit)="addCharges()" (keydown.enter)="useEnterKey ? $event.preventDefault() : addCharges()">
        <div class="col-12">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-2">
                            <div class="mb-1">
                                <label for="chargetype" class="form-label">Charge Type<span
                                        class="mandatory">*</span></label>
                                <ng-select id="chargetype" placeholder="Select" [items]="chargeTypeOptions"
                                    [appendTo]="'body'" [openOnEnter]="false" [multiple]="true" formControlName="ddlChargeType"
                                    class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                    [ngClass]="{'is-invalid': (isFormSubmitted || chargesForm.get('ddlChargeType').touched) && chargesForm.get('ddlChargeType').errors}" >
                                </ng-select>
                                <div *ngIf="(isFormSubmitted || chargesForm.get('ddlChargeType').touched) && chargesForm.get('ddlChargeType').errors"
                                    class="invalid-feedback">
                                    <span *ngIf="chargesForm.get('ddlChargeType').errors.required">Charge Type
                                        is required</span>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="mb-1">
                                <label for="name" class="form-label">Name<span class="mandatory">*</span></label>
                                <input type="text" class="form-control form-control-sm" id="name"
                                    formControlName="txtName" maxlength="50"
                                    [ngClass]="{'is-invalid': (isFormSubmitted || chargesForm.get('txtName').touched) && chargesForm.get('txtName').errors}" >
                                <div *ngIf="(isFormSubmitted || chargesForm.get('txtName').touched) && chargesForm.get('txtName').errors"
                                    class="invalid-feedback">
                                    <span *ngIf="chargesForm.get('txtName').errors.required">Name is required</span>
                                    <span *ngIf="chargesForm.get('txtName').errors.maxlength">The maximum length is 50
                                        characters</span>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="mb-1">
                                <label for="calculationbase" class="form-label">Calculation Base<span
                                        class="mandatory">*</span></label>
                                <ng-select id="calculationbase" placeholder="Select" [items]="calculationBaseOptions"
                                    bindLabel="name" [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false"
                                    formControlName="ddlCalculationBaseId"
                                    class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                    [ngClass]="{'is-invalid': (isFormSubmitted || chargesForm.get('ddlCalculationBaseId').touched) && chargesForm.get('ddlCalculationBaseId').errors}" >
                                </ng-select>
                                <div *ngIf="(isFormSubmitted || chargesForm.get('ddlCalculationBaseId').touched) && chargesForm.get('ddlCalculationBaseId').errors"
                                    class="invalid-feedback">
                                    <span *ngIf="chargesForm.get('ddlCalculationBaseId').errors.required">Calculation
                                        Base is required</span>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="mb-1">
                                <label for="amount" class="form-label">Amount</label>
                                <input type="number" class="form-control form-control-sm" id="amount"
                                    formControlName="txtAmount" (keydown)="amountDisable($event)"
                                    [ngClass]="{'is-invalid': (isFormSubmitted || chargesForm.get('txtAmount').touched) && chargesForm.get('txtAmount').errors}" >
                                <div *ngIf="(isFormSubmitted || chargesForm.get('txtAmount').touched) && chargesForm.get('txtAmount').errors"
                                    class="invalid-feedback">
                                    <span *ngIf="chargesForm.get('txtAmount').errors.pattern">Invalid Amount
                                        Format</span>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="mb-1">
                                <label for="hsncode" class="form-label">HSN Code</label>
                                <input type="text" class="form-control form-control-sm" id="hsncode"
                                    formControlName="txtHSNCode" maxlength="10"
                                    [ngClass]="{'is-invalid': (isFormSubmitted || chargesForm.get('txtHSNCode').touched) && chargesForm.get('txtHSNCode').errors}" >
                                <div *ngIf="(isFormSubmitted || chargesForm.get('txtHSNCode').touched) && chargesForm.get('txtHSNCode').errors"
                                    class="invalid-feedback">
                                    <span *ngIf="chargesForm.get('txtHSNCode').errors.maxlength">The maximum length is
                                        10 characters</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-5">
                            <div class="mb-1">
                                <label for="charges" class="form-label">Multiple Charges</label>
                                <ng-multiselect-dropdown class=" form-control-sm" [placeholder]="'Select Charges'" (keydown.enter)="tax.focus()"
                                    [settings]="dropDownSettings" [data]="chargesOptions" formControlName="ddlCharges" >
                                </ng-multiselect-dropdown>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4 d-flex">
                            <div class="mb-2 me-3">
                                <label for="taxSwitch" class="form-label">Tax</label>
                                <div #tax class="form-check form-switch form-switch-md mb-2">
                                    <input type="checkbox" id="taxSwitch" class="form-check-input"
                                        formControlName="txtTaxSwitch"  (change)="updateTaxOnFuelSwitch()">
                                </div>
                            </div>
                            <div class="mb-2 me-3">
                                <label for="fuelSwitch" class="form-label">Fuel</label>
                                <div class="form-check form-switch form-switch-md mb-2">
                                    <input type="checkbox" id="fuelSwitch" class="form-check-input"
                                        formControlName="txtFuelSwitch"  (change)="updateTaxOnFuelSwitch()">
                                </div>
                            </div>
                            <div class="mb-2">
                                <label for="taxOnFuelSwitch" class="form-label">Tax On Fuel</label>
                                <div class="form-check form-switch form-switch-md mb-2">
                                    <input type="checkbox" id="taxOnFuelSwitch" class="form-check-input" 
                                        formControlName="txtTaxOnFuelSwitch" 
                                        (change)="updateTaxFuel()">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-2">
                            <div class="mb-2">
                                <label for="statusSwitch" class="form-label">Status</label>
                                <div class="form-check form-switch form-switch-md mb-2">
                                    <input type="checkbox" id="statusSwitch" class="form-check-input"
                                        formControlName="txtStatusSwitch" >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="button-items">
            <button type="submit" class="btn btn-primary w-md" [disabled]="isAddDisable" >Add</button>
            <a routerLink="/config/charges/manage"><button type="button"
                    class="btn btn-secondary w-md">Cancel</button></a>
        </div>
    </form>
</div>
</ng-container>
<ng-container *ngIf="!permConfig.isAddAllowed">
    <app-forbidden></app-forbidden>
</ng-container>